import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { skechersColorEntity } from "../entity/skechers-color-entity";

@Injectable()
export class ColorRepo extends Repository<skechersColorEntity> {

    constructor(@InjectRepository(skechersColorEntity) private repo: Repository<skechersColorEntity>
    ) {
        super(repo.target, repo.manager, repo.queryRunner);
    }
}